<div class="discounts-panel">
    <div class="btns-filters">
        <div class="filters-left">
            <div class="buscador-event container-form d-flex align-items-center borderInput">
                <i class="fal fa-search search-icon pointer-in"></i>
                <input class="input-custom w-100" type="text" placeholder="Buscar descuento"
                    [ngModel]="searchText" (input)="onSearch($any($event.target).value)">
            </div>
            <div class="filter-group">
                <div class="filter-pill" [class.active]="ruleTypeFilter !== ''" (click)="typeDropdownOpen = !typeDropdownOpen; statusDropdownOpen = false">
                    <i class="fal fa-layer-group"></i>
                    <span>{{ ruleTypeFilter ? getRuleTypeLabel(ruleTypeFilter) : 'Tipo' }}</span>
                    <i class="fal fa-chevron-down chevron" [class.open]="typeDropdownOpen"></i>
                </div>
                <div class="filter-dropdown" *ngIf="typeDropdownOpen">
                    <div class="filter-option" [class.selected]="ruleTypeFilter === ''" (click)="ruleTypeFilter = ''; typeDropdownOpen = false; onFilterChange()">Todos</div>
                    <div class="filter-option" [class.selected]="ruleTypeFilter === 'promo_code'" (click)="ruleTypeFilter = 'promo_code'; typeDropdownOpen = false; onFilterChange()">Código promo</div>
                    <div class="filter-option" [class.selected]="ruleTypeFilter === 'bundle'" (click)="ruleTypeFilter = 'bundle'; typeDropdownOpen = false; onFilterChange()">Por paquete</div>
                    <div class="filter-option" [class.selected]="ruleTypeFilter === 'volume'" (click)="ruleTypeFilter = 'volume'; typeDropdownOpen = false; onFilterChange()">Por volumen</div>
                </div>
            </div>
            <div class="filter-group">
                <div class="filter-pill" [class.active]="activeFilter !== ''" (click)="statusDropdownOpen = !statusDropdownOpen; typeDropdownOpen = false">
                    <i class="fal fa-signal-bars"></i>
                    <span>{{ activeFilter === 'true' ? 'Activo' : activeFilter === 'false' ? 'Inactivo' : 'Estado' }}</span>
                    <i class="fal fa-chevron-down chevron" [class.open]="statusDropdownOpen"></i>
                </div>
                <div class="filter-dropdown" *ngIf="statusDropdownOpen">
                    <div class="filter-option" [class.selected]="activeFilter === ''" (click)="activeFilter = ''; statusDropdownOpen = false; onFilterChange()">Todos</div>
                    <div class="filter-option" [class.selected]="activeFilter === 'true'" (click)="activeFilter = 'true'; statusDropdownOpen = false; onFilterChange()">Activo</div>
                    <div class="filter-option" [class.selected]="activeFilter === 'false'" (click)="activeFilter = 'false'; statusDropdownOpen = false; onFilterChange()">Inactivo</div>
                </div>
            </div>
            <button class="btn-clear" *ngIf="ruleTypeFilter || activeFilter || searchText" (click)="clearFilters()">
                <i class="fal fa-xmark"></i> Limpiar
            </button>
        </div>
        <div class="btns-create">
            <div class="btn-create m-0" (click)="openCreate()">
                <i class="fal fa-plus-circle"></i>
                <p class="m-0">Crear descuento</p>
            </div>
        </div>
    </div>

    <div *ngIf="loadingPage" class="container-lottie">
        <div class="loading-container">
            <ng-lottie class="lottie" [options]="{path: 'assets/lotties/loading.json'}"
                containerClass="loading-box"></ng-lottie>
        </div>
    </div>

    <div class="table-events table-panel multiple-lines" *ngIf="loaded">
        <table mat-table [dataSource]="dataSource" class="mat-elevation-z28" matSort>
            <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef>Acciones</th>
                <td mat-cell *matCellDef="let d">
                    <div [matMenuTriggerFor]="actionMenu" class="pointer-in d-flex justify-content-center"
                        style="width: 20px;">
                        <i class="icon-option fal fa-ellipsis-vertical"></i>
                    </div>
                    <mat-menu class="options-menu-control-panel" #actionMenu="matMenu">
                        <button mat-menu-item (click)="openEdit(d)"><i class="fal fa-pen-to-square" style="margin-right: 8px;"></i>Editar</button>
                        <button mat-menu-item (click)="toggleActive(d)">
                            <i class="fal" [ngClass]="d.active ? 'fa-toggle-off' : 'fa-toggle-on'" style="margin-right: 8px;"></i>
                            {{d.active ? 'Desactivar' : 'Activar'}}
                        </button>
                        <button mat-menu-item (click)="deleteDiscount(d)" class="delete-action"><i class="fal fa-trash-can" style="margin-right: 8px;"></i>Eliminar</button>
                    </mat-menu>
                </td>
            </ng-container>

            <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef mat-sort-header><b><i class="fal fa-tag th-icon"></i> Nombre</b></th>
                <td mat-cell *matCellDef="let d" (click)="openEdit(d)">
                    <span class="link-titulo">{{d.name}}</span>
                </td>
            </ng-container>

            <ng-container matColumnDef="rule_type">
                <th mat-header-cell *matHeaderCellDef><b><i class="fal fa-layer-group th-icon"></i> Tipo</b></th>
                <td mat-cell *matCellDef="let d">
                    <span class="type-badge" [ngClass]="{
                        'type-badge--promo': d.rule_type === 'promo_code',
                        'type-badge--bundle': d.rule_type === 'bundle',
                        'type-badge--volume': d.rule_type === 'volume'
                    }">
                        <i class="fal" [ngClass]="{
                            'fa-ticket': d.rule_type === 'promo_code',
                            'fa-box-open': d.rule_type === 'bundle',
                            'fa-chart-bar': d.rule_type === 'volume'
                        }"></i>
                        {{getRuleTypeLabel(d.rule_type)}}
                    </span>
                </td>
            </ng-container>

            <ng-container matColumnDef="value">
                <th mat-header-cell *matHeaderCellDef><b><i class="fal fa-percent th-icon"></i> Valor</b></th>
                <td mat-cell *matCellDef="let d">
                    <span class="value-display">{{getValueDisplay(d)}}</span>
                </td>
            </ng-container>

            <ng-container matColumnDef="dates">
                <th mat-header-cell *matHeaderCellDef><b><i class="fal fa-calendar-range th-icon"></i> Vigencia</b></th>
                <td mat-cell *matCellDef="let d">
                    <span class="dates-display">
                        <i class="fal fa-clock" style="margin-right: 4px; opacity: 0.5;"></i>
                        {{getDatesDisplay(d)}}
                    </span>
                </td>
            </ng-container>

            <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef><b><i class="fal fa-signal-bars th-icon"></i> Estado</b></th>
                <td mat-cell *matCellDef="let d">
                    <span class="status-badge" [ngClass]="d.active ? 'status-badge--active' : 'status-badge--inactive'">
                        <i class="fa-solid" [ngClass]="d.active ? 'fa-circle-check' : 'fa-circle-xmark'"></i>
                        {{d.active ? 'Activo' : 'Inactivo'}}
                    </span>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
    </div>

    <div *ngIf="loaded && !loadingPage && discounts.length === 0" class="empty-state">
        <i class="fal fa-tags"></i>
        <p>No hay descuentos configurados</p>
        <span>Crea tu primer descuento para empezar</span>
    </div>
</div>
